'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

function getFileFromBlob(blobPart, fileName, contentType) {
  if (!fileName || !contentType) {
    return;
  }

  const blob = new Blob([blobPart], { type: contentType });
  const file = new File([blob], fileName);

  return file;
}

function downloadFile(file) {
  const fileName = file.name;

  // For IE
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveOrOpenBlob(file, fileName);
  } else {
    const link = document.createElement('a');

    link.style.display = 'none';
    link.href = window.URL.createObjectURL(file);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    // For Firefox, we need to postpone the removal of the link
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      link.remove();
    }, 0)
  }
}

angular.module('directives.userRequestFollowups', [
    'services.userAccessRequest',
    'services.authenticatedUser',
    'angularFileUpload'
])

.directive('userRequestFollowups', ['$upload', 'authenticatedUserService', 'userAccessRequestService', '$http', function ($upload, authenticatedUserService, userAccessRequestService, $http) {
    return {
        scope: {
            requestId: '=?',
            request: '=?',
            followupId: '=?'
        },
        template: '<div ng-include="getTemplateUrl()"></div>',
        link: function (scope, elem, attrs) {

            // Get authenticated user
            authenticatedUserService.getAuthenticatedUser()
            .then(function (authUser) {
                scope.authenticatedUser = authUser;
            });

            // Get Template
            scope.version = angular.isDefined(attrs.version) ? attrs.version : 'full';
            scope.getTemplateUrl = function () {
                return '/app/shared/components/directives/userRequestFollowups.' + scope.version + '.tpl.html';
            }

            if (_.isUndefined(scope.request)) {
                scope.request = {};
                scope.request.UserAccessRequestID = scope.requestId;
            }

            scope.followups = [];
            scope.followup = {};
            scope.followup.newComment = null;
            scope.followup.lastFollowup = null;
            scope.followup.Attachments = [];

            scope.setLeftOrRightSide = function (previous, actual) {
                if (_.isUndefined(previous)) {
                    actual.isLeftSide = true;
                    return;
                }

                if (_.isUndefined(previous.isLeftSide)) previous.isLeftSide = true;

                if (previous.EmployeeID === actual.EmployeeID) {
                    actual.isLeftSide = previous.isLeftSide;
                }
                else {
                    actual.isLeftSide = !previous.isLeftSide;
                }
            }

            scope.downloadAttachment = function (existingAttachment) {
              $http({
                method: 'GET',
                url: scope.getDownloadUrl(existingAttachment.AttachmentExternalID),
                responseType: 'blob'
              }).then(function (response) {
                const file = getFileFromBlob(response.data, existingAttachment.FileName, response.data.type);
                downloadFile(file);
              });
            }

            scope.getDownloadUrl = function (attachmentExternalId) {
                var baseUrl = environment.apiUrl + '/ID/API/Attachment/';
                return baseUrl + 'Download/' + attachmentExternalId;
            };

            scope.isLeftSide = function (followup) {
                return _.isUndefined(followup.isLeftSide) || followup.isLeftSide;
            }

            scope.isRightSide = function (followup) {
                return !_.isUndefined(followup.isLeftSide) && !followup.isLeftSide;
            }

            scope.withoutNewComment = function () {
                return _.isNull(scope.followup.newComment);
            }

            scope.createFollowup = function () {
                userAccessRequestService.createFollowup(scope.request.UserAccessRequestID,
                                                        scope.followup.newComment,
                                                        scope.followup.Attachments)
                                        .then(function (createdFollowup) {

                                            var mostRecentFollowup = _.first(scope.followups);
                                            scope.setLeftOrRightSide(mostRecentFollowup, createdFollowup);

                                            createdFollowup.Attachments = scope.followup.Attachments;

                                            scope.followups.unshift(createdFollowup);

                                            scope.followup.newComment = null;
                                            scope.followup.Attachments = [];
                                        });
            }

            scope.cancelFollowup = function () {
                userAccessRequestService.cancelFollowup(scope.request.UserAccessRequestID,
                                                        scope.followup.newComment,
                                                        scope.followup.Attachments)
                                        .then(function () {
                                            scope.followup.newComment = null;
                                            scope.followup.Attachments = [];
                                        });
            }

            scope.fileSelected = function (files, events) {
                for (var idxFile = 0; idxFile < files.length; idxFile++) {
                    var file = files[idxFile];

                    scope.upload = $upload.upload({
                        url: environment.apiUrl + '/ID/API/Attachment/Upload',
                        method: 'POST',
                        data: {},
                        file: file
                    }).progress(function (evt) {
                        //console.log('percent: ' + parseInt(100.0 * evt.loaded / evt.total));
                    }).success(function (data, status, headers, config) {
                        scope.followup.Attachments.push(data);
                    });
                };
            };

            scope.getFollowupsByRequestID = function () {
                scope.followups = [];
                if (_.isUndefined(scope.request.UserAccessRequestID)) return;

                userAccessRequestService.getFollowupsByRequestID(scope.request.UserAccessRequestID)
                                        .then(function (followups) {
                                            scope.followups = [];
                                            scope.followup.lastFollowup = _.first(followups);
                                            var oldestFollowup = _.reduce(followups, function (previous, actual) {
                                                scope.setLeftOrRightSide(previous, actual);
                                                scope.followups.push(previous);
                                                return actual;
                                            });
                                            if (!_.isUndefined(oldestFollowup)) {
                                                scope.followups.push(oldestFollowup);
                                            }
                                        });
            }

            scope.getFollowupByFollowup = function () {
                userAccessRequestService.getFollowupByFollowup(scope.followupId)
                                        .then(function (followup) {
                                            scope.followup.lastFollowup = followup;
                                        });
            }

            scope.$watch('requestId', function (newValue, oldValue) {
                if (newValue) {
                    scope.request.UserAccessRequestID = newValue;
                    scope.getFollowupsByRequestID();
                }
            });

            scope.$watch('request', function (newValue, oldValue) {
                if (newValue) {
                    scope.request = newValue;
                    scope.getFollowupsByRequestID();
                }
            });

            scope.$watch('followupId', function (newValue, oldValue) {
                if (newValue) {
                    scope.getFollowupByFollowup();
                }
            });
        }
    }
}]);
